import { useState, useEffect } from 'react'
import { useParams } from 'react-router-dom'
import { getPublicHistory, getUserProfile } from '../services/movies'
import { doc, getDoc } from '../services/firebase'
import { db } from '../services/firebase'
import MovieGrid from '../components/movie/MovieGrid'
import Loader from '../components/common/Loader'
import './SharedHistory.css'

function SharedHistory() {
  const { userId } = useParams()
  const [movies, setMovies] = useState([])
  const [userInfo, setUserInfo] = useState(null)
  const [loading, setLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const fetchData = async () => {
      try {
        // Get user info
        const userDoc = await getDoc(doc(db, 'users', userId))
        if (userDoc.exists()) {
          setUserInfo(userDoc.data())
        }

        // Get public history
        const history = await getPublicHistory(userId)
        setMovies(history)
      } catch (err) {
        setError(err.message === 'History is private' 
          ? 'Este historial es privado' 
          : 'No se pudo cargar el historial'
        )
      } finally {
        setLoading(false)
      }
    }

    if (userId) {
      fetchData()
    }
  }, [userId])

  if (loading) {
    return <Loader fullScreen />
  }

  if (error) {
    return (
      <div className="page shared-history-page">
        <div className="container">
          <div className="error-state">
            <div className="error-icon">🔒</div>
            <h1>{error}</h1>
            <p className="text-secondary">
              El usuario no ha compartido su historial públicamente
            </p>
          </div>
        </div>
      </div>
    )
  }

  return (
    <div className="page shared-history-page">
      <div className="container">
        <div className="shared-header">
          <div className="shared-user-info">
            {userInfo?.photoURL ? (
              <img src={userInfo.photoURL} alt="" className="shared-avatar" />
            ) : (
              <div className="shared-avatar shared-avatar-placeholder">
                {userInfo?.displayName?.charAt(0) || '?'}
              </div>
            )}
            <div>
              <h1 className="shared-title">
                Historial de {userInfo?.displayName || 'Usuario'}
              </h1>
              <p className="text-secondary">
                {movies.length} película{movies.length !== 1 ? 's' : ''} vista{movies.length !== 1 ? 's' : ''}
              </p>
            </div>
          </div>
        </div>

        <MovieGrid 
          movies={movies}
          showRating
          emptyMessage="Este usuario aún no ha registrado películas"
        />
      </div>
    </div>
  )
}

export default SharedHistory
